import WTBHero from './components/WTBHero';
import SharedTrustBar from '../../components/feature/SharedTrustBar';
import StoreSection from './components/StoreSection';
import MidCTA from '../../components/feature/MidCTA';
import SharedAIBlock from '../../components/feature/SharedAIBlock';
import SharedHowItWorks from '../../components/feature/SharedHowItWorks';
import SharedWhyChooseUs from '../../components/feature/SharedWhyChooseUs';
import DistributorSection from './components/DistributorSection';
import SharedTestimonials from '../../components/feature/SharedTestimonials';
import SharedFAQ from '../../components/feature/SharedFAQ';
import SharedFinalCTA from '../../components/feature/SharedFinalCTA';
import { whereToBuyAIItems, whyReasons } from '../../mocks/shared-sections';
import { distributionFaqs } from '../../mocks/faqs';

const howToGetYourKitSteps = [
  {
    number: '01',
    title: 'Find a Store Near You',
    description: 'Use our store finder below to locate the nearest surf shop stocking PHIX Doctor in 60+ countries.',
    image: 'https://public.readdy.ai/ai/img_res/92704af4767a359c8eb5850f6623952d.jpg',
  },
  {
    number: '02',
    title: 'Or Shop Online',
    description: 'Can\'t find a local store? Shop our full range online. Worldwide shipping, orders ship within 24 hours.',
    image: 'https://readdy.ai/api/search-image?query=person%20shopping%20online%20laptop%20surfboard%20repair%20kits%20home%20casual%20surf%20lifestyle%20photography%20natural%20light&width=400&height=280&seq=wtb_step2&orientation=landscape',
  },
  {
    number: '03',
    title: 'Choose Your Kit',
    description: 'Select the kit for your board type — Universal, Epoxy, Polyester, Softboard, or Micro for travel.',
    image: 'https://readdy.ai/api/search-image?query=surfboard%20repair%20kits%20selection%20variety%20products%20displayed%20surf%20shop%20shelf%20retail%20professional&width=400&height=280&seq=wtb_step3&orientation=landscape',
  },
  {
    number: '04',
    title: 'Fast Delivery',
    description: 'Orders ship within 24 hours. Most destinations receive their kit within 1–3 business days.',
    image: 'https://readdy.ai/api/search-image?query=package%20delivery%20surfboard%20repair%20kit%20box%20delivered%20to%20door%20surf%20house%20porch%20lifestyle&width=400&height=280&seq=wtb_step4&orientation=landscape',
  },
  {
    number: '05',
    title: 'Repair & Surf',
    description: 'Fix any ding in minutes with sun-powered resin. Back in the water the same session.',
    image: 'https://readdy.ai/api/search-image?query=surfer%20running%20into%20ocean%20with%20repaired%20surfboard%20happy%20excited%20beach%20waves%20sunny%20lifestyle%20photography&width=400&height=280&seq=wtb_step5&orientation=landscape',
  },
];

export default function WhereToBuyPage() {
  return (
    <main className="min-h-screen">
      {/* 1. Hero */}
      <WTBHero />
      {/* 2. Trust Bar */}
      <SharedTrustBar />
      {/* 3. Store Section */}
      <StoreSection />
      {/* Mid CTA */}
      <MidCTA
        headline="Can't Find a Store? Shop Online."
        sub="Fast worldwide shipping. Full product range. Orders ship within 24 hours."
        btnLabel="Shop Online Now"
        btnTo="/products"
        urgency="Free shipping on orders over $50"
        variant="teal"
      />
      {/* 4. AI Answer Block */}
      <SharedAIBlock
        title="Where to Find PHIX Doctor"
        subtitle="Answers about availability, travel regulations, and how to get your kit."
        items={whereToBuyAIItems}
        bgClass="bg-[#F5EFE6]"
      />
      {/* 5. How It Works — how to get your kit */}
      <SharedHowItWorks
        title="How to Get Your Kit"
        subtitle="Getting your hands on PHIX Doctor is as easy as using it. Here's how."
        steps={howToGetYourKitSteps}
        bgClass="bg-white"
      />
      {/* 6. Why Choose PHIX Doctor */}
      <SharedWhyChooseUs
        reasons={whyReasons}
        showComparison={true}
        bgClass="bg-[#F5EFE6]"
      />
      {/* Mid CTA after Why Choose Us */}
      <MidCTA
        headline="Still Not Sure Which Kit to Buy?"
        sub="The Universal Kit is our most popular and works on every board type."
        btnLabel="Shop Universal Kit"
        btnTo="/products/universal-sunpowered-kit"
        urgency="Best Seller · 4.9★ · 1,284 reviews"
        variant="orange"
      />
      {/* 7. Distributor / Global Section */}
      <DistributorSection />
      {/* 8. Testimonials */}
      <SharedTestimonials />
      {/* 9. FAQ */}
      <SharedFAQ
        faqs={distributionFaqs}
        title="Distribution FAQ"
        subtitle="Common questions about buying, shipping, and retailing PHIX Doctor."
        bgClass="bg-white"
      />
      {/* 10. Final CTA */}
      <SharedFinalCTA
        headline="Find Your Kit —"
        headlineAccent="Fix Your Board Today."
        primaryLabel="Find a Retailer"
        primaryTo="/where-to-buy"
        secondaryLabel="Shop Online"
        secondaryTo="/products"
        urgency="Don't let a ding decide whether you surf today."
        offer="Free shipping on orders over $50"
      />
    </main>
  );
}
